import type { PeriodStats } from "../../../api/stats/Stats.typed";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import type { StatsTemplateTableConfig } from "../statsPeriodHelpers";
import StatsTemplateTable from "./StatsTemplateTable";

type StatsTemplateCardProps = {
  config: StatsTemplateTableConfig;
  stats: PeriodStats;
};

export default function StatsTemplateCard({ config, stats }: StatsTemplateCardProps) {
  return (
    <DarkCard sx={{ minWidth: 0, overflowX: "auto" }}>
      <DarkTypography level="title-md" colorVariant="title" sx={{ mb: 1.5 }}>
        {config.title}
      </DarkTypography>
      <StatsTemplateTable config={config} stats={stats} />
    </DarkCard>
  );
}
